import { render } from "./LearningModule.vue?vue&type=template&id=68b0c098"
import script from "./LearningModule.vue?vue&type=script&lang=js"
export * from "./LearningModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__